
document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth >= 749) {
    const tabs = document.querySelectorAll('.facets-popup-modal--tab');
    tabs.forEach(function(tab) {
      tab.classList.add('active');
    });
  }
});



    document.addEventListener("DOMContentLoaded", function() {
    var toggleButton = document.getElementById("Facets-Toggle-Fixed");
    var winnerElement = document.querySelector(".z-winner");
    toggleButton.addEventListener("click", function() {
        if (window.innerWidth <= 768) {
            winnerElement.style.display = "block";
        }
    });
});
 

document.addEventListener('DOMContentLoaded', function() {
    // Mapping of first letters to class names
    const letterToClassMap = {
        'A': 'a.A.The.one.combination.you.can.always.rely.on',
        'Q': 'a.Q.Instantly.find.your.style',
        'U': 'a.U.The.one.combination.you.can.always.rely.on',
        // Add more mappings as needed
    };

    // Select all elements with the specified class
    var links = document.querySelectorAll('.link-with-hidden-first-letter');
    
    // Loop through each link and apply the transformation
    links.forEach(function(link) {
        // Get the first letter of the link text
        var firstLetter = link.textContent.trim()[0].toUpperCase();
        
        // Find the corresponding class name from the map
        var className = letterToClassMap[firstLetter];
        
        // Check if a class name was found and apply it
        if (className) {
            link.classList.add(className);
            
            // Optionally, wrap the first letter in a span with a specific class for styling
            link.innerHTML = '<span class="hidden-first-letter">' + link.textContent[0] + '</span>' + link.textContent.slice(1);
        }
    });
});





  document.addEventListener("DOMContentLoaded", function() {
            const header = document.getElementById("header");
            if (window.location.href.includes("product")) {
                header.classList.add("is-sticky");

                // Create a MutationObserver to monitor the class attribute
                const observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        if (mutation.type === "attributes" && mutation.attributeName === "class") {
                            if (!header.classList.contains("is-sticky")) {
                                header.classList.add("is-sticky");
                            }
                        }
                    });
                });

                // Configure the observer to watch for attribute changes
                observer.observe(header, { attributes: true });

                // Optional: ensure the observer cannot be tampered with
                Object.freeze(observer);
            }
        });


// remove br tag from mobile

    function removeBrTags() {
        var isMobileScreen = window.innerWidth < 749 && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        if (isMobileScreen) {
            var brTags = document.querySelectorAll('.image-with-text__content--inner br');
            brTags.forEach(function(br) {
                br.parentNode.removeChild(br);
            });
        }
    }
    removeBrTags();
    window.addEventListener('resize', removeBrTags);

// end  remove br tag from mobile






  // Step 1: Select the <h1> element
const h1Element = document.querySelector('h1.entry-title');

if (h1Element) {
  // Step 2: Get the innerText of the <h1> element
  let textContent = h1Element.innerText;

  // Step 3: Remove the first letter
  textContent = textContent.slice(1); // Removes the first character

  // Step 4: Update the innerText of the <h1> element
  h1Element.innerText = textContent;
}




document.addEventListener('DOMContentLoaded', function() {
  // Assuming .new_new_heading could apply to multiple elements
  const h1Elements = document.querySelectorAll('.new_new_heading');
  
  h1Elements.forEach(function(h1Element) {
    // Step 2: Get the innerText of the <h1> element
    let textContent = h1Element.innerText;

    // Step 3: Remove the first letter
    textContent = textContent.slice(1); // Removes the first character

    // Step 4: Update the innerText of the <h1> element
    h1Element.innerText = textContent;
  });
});

